import {
	Button,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
} from "@material-ui/core";
import numeral from "numeral";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import UpdateField from "../Popover/UpdateField";

const CompraProgramada = forwardRef((props, ref) => {
	const [ancolaParcela, setAncoraParcela] = useState(null);
	const [valorParcelaAlterando, setValorParcelaAlterando] = useState(null);
	const [popOverOpen, setPopOverOpen] = useState(null);

	useImperativeHandle(ref, () => ({
		updateCompraProgramada() {
			updateCompraProgramada();
		},
	}));

	const compraProgramadaSize = (quantidadeParcelas) => {
		let parcelas = [];
		for (let i = 1; i <= quantidadeParcelas; i++) {
			parcelas.push(
				(props.orcamentoResumo.totalParcelas / quantidadeParcelas).toFixed(2)
			);
		}
		props.setCompraProgramada(parcelas);
	};

	const SetPagamentoMetodosSelecteds = (id, name, installments, value) => {
		if (
			props.paymentMethodsSelecteds[id] &&
			props.paymentMethodsSelecteds[id].name === name &&
			props.paymentMethodsSelecteds[id].installments === installments
		) {
			let data = [];
			for (var key of Object.keys(props.paymentMethodsSelecteds)) {
				if (name !== props.paymentMethodsSelecteds[key].name) {
					data.push(props.paymentMethodsSelecteds[key]);
				}
			}

			if (name === "Compra programada") {
				props.setCompraProgramadaSelecionada(false);
			}

			props.SetPagamentoMetodosSelecteds(data);
		} else {
			if (id === 7) props.setCompraProgramadaSelecionada(true);

			props.SetPagamentoMetodosSelecteds({
				...props.paymentMethodsSelecteds,
				[id]: {
					name: name,
					installments: installments,
					value: value,
				},
			});
		}
	};

	const alterarPrimeiraParcela = (event) => {
		setAncoraParcela(event.currentTarget);
		setValorParcelaAlterando(props.compraProgramada[0]);
		setPopOverOpen("alterarValorParcela");
	};

	const handleClose = () => {
		setAncoraParcela(null);
		setPopOverOpen(null);
	};

	const aplicarValorParcela = () => {
		setPopOverOpen(null);
		updateCompraProgramada(0, valorParcelaAlterando);
		setValorParcelaAlterando(null);
		setAncoraParcela(null);

		let data = [];
		for (var key of Object.keys(props.paymentMethodsSelecteds)) {
			if ("Compra programada" !== props.paymentMethodsSelecteds[key].name) {
				data.push(props.paymentMethodsSelecteds[key]);
			}
		}

		props.setCompraProgramadaSelecionada(false);

		props.SetPagamentoMetodosSelecteds(data);
	};

	const updateCompraProgramada = (index, value = null) => {
		let parcelas = [];

		const _value = value !== null ? value : props.compraProgramada[0];
		const compraProgramadaLength = props.compraProgramada.length;
		const others =
			(props.orcamentoResumo.totalParcelas - _value) /
			(compraProgramadaLength - 1);
		props.compraProgramada.map((item, i) => {
			if (i === 0) {
				parcelas.push(_value);
			} else {
				parcelas.push(others).toFixed(2);
			}
		});
		props.setCompraProgramada(parcelas);
	};

	return (
		<>
			<UpdateField
				elementId={"alterarValorParcela"}
				label={"Valor da primeira parcela"}
				popOverOpen={popOverOpen}
				anchorEl={ancolaParcela}
				handleClose={handleClose}
				valorAlterado={valorParcelaAlterando}
				setValorAlterando={setValorParcelaAlterando}
				atualizaPor={aplicarValorParcela}
			/>
			<div className="d-flex m-1 align-items-center">
				Quantidade de parcelas
				<Select
					className="ml-1 mr-1"
					native
					value={props.compraProgramada.length}
					onChange={(e) => compraProgramadaSize(e.target.value)}
				>
					<option value={18}>18</option>
					<option value={17}>17</option>
					<option value={16}>16</option>
					<option value={15}>15</option>
					<option value={14}>14</option>
					<option value={13}>13</option>
					<option value={12}>12</option>
					<option value={11}>11</option>
					<option value={10}>10</option>
					<option value={9}>9</option>
					<option value={8}>8</option>
					<option value={7}>7</option>
					<option value={6}>6</option>
					<option value={5}>5</option>
					<option value={4}>4</option>
					<option value={3}>3</option>
					<option value={2}>2</option>
				</Select>
				<Button
					variant="contained"
					size="small"
					onClick={() => {
						let valor =
							"Primeira parcela de " +
							numeral(parseFloat(props.compraProgramada[0])).format(
								"$ 0,0.00"
							) +
							" mais " +
							(props.compraProgramada.length - 1) +
							" de " +
							numeral(parseFloat(props.compraProgramada[1])).format("$ 0,0.00");
						if (
							props.compraProgramada.length > 1 &&
							parseFloat(props.compraProgramada[0]) ===
								parseFloat(props.compraProgramada[1])
						) {
							valor =
								props.compraProgramada.length +
								" vezes de " +
								numeral(parseFloat(props.compraProgramada[0])).format(
									"$ 0,0.00"
								);
						}
						SetPagamentoMetodosSelecteds(7, "Compra programada", 0, valor);
					}}
				>
					{props.compraProgramadaSelecionada
						? "Remover método"
						: "Selecionar método"}
				</Button>
			</div>
			<TableContainer>
				<Table size="small" className="tableCoefficient">
					<TableBody>
						<React.Fragment>
							{props.compraProgramada.map((value, i) => {
								return (
									<TableRow key={i}>
										<TableCell>{i + 1}&deg; parcela de</TableCell>
										<TableCell align="right">
											{i === 0 && (
												<Button
													size="medium"
													variant="contained"
													color="primary"
													onClick={alterarPrimeiraParcela}
													className="btn-extra-small"
												>
													{numeral(parseFloat(value)).format("$ 0,0.00")}
												</Button>
											)}
											{i > 0 && numeral(parseFloat(value)).format("$ 0,0.00")}
										</TableCell>
									</TableRow>
								);
							})}
						</React.Fragment>
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
});

export default CompraProgramada;
